<!-- Ported from the Polaris kit: src/product/components/MiddleTruncate.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first. -->
<script setup>
// A name that keeps both of its ends. The start says what the thing is, the end carries what tells two of them apart: a revision,
// a year, the extension. Cutting only the end ("Procedimento-O…") throws that away, so the cut goes in the middle. The whole name
// stays in the title, and in the accessible name, for anyone who needs it.
import { computed } from 'vue';

const props = defineProps({
  text: { type: String, required: true },
  tail: { type: Number, default: 8 }, // characters kept at the end: a year and an extension
});
// Below this there is nothing to gain: the name is shown whole.
const cut = computed(() => props.text.length > props.tail + 8);
const head = computed(() =>
  cut.value ? props.text.slice(0, -props.tail) : props.text
);
const end = computed(() => (cut.value ? props.text.slice(-props.tail) : ''));
</script>

<template>
  <span class="flex min-w-0 items-baseline" :title="text" :aria-label="text">
    <!-- whitespace-pre: without it a space at the cut ("Manual do CardioMax " + "DEA-4000") is collapsed away and two words run together. -->
    <span class="truncate whitespace-pre">{{ head }}</span>
    <span v-if="end" class="shrink-0 whitespace-pre">{{ end }}</span>
  </span>
</template>
